module.exports = __webpack_public_path__ + "img/54.8.TSS.8779ccf4.png";